import { useContext } from 'react';
import { CommunityContext } from '../context';

interface IApiV2UploadFile {
  file: File;
  updateProgress: (percent: number) => void;
}

export const useApiV2 = () => {
  const community = useContext(CommunityContext);

  const upload = async ({ file, updateProgress }: IApiV2UploadFile) => {
    const data = new FormData();
    data.append('file', file);
    data.append(
      'data',
      JSON.stringify({
        use_filename: true,
        hubbubId: community.id
      })
    );
    data.append('hubbubUrl', community.url);
    data.append('hubbubId', community.id);

    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/proxy/file');
    // Send the httpOnly user_pkey cookie cross-origin so the proxy authenticates the upload.
    xhr.withCredentials = true;
    xhr.upload.addEventListener('progress', (event) => {
      const { loaded, total } = event;
      const validLoaded = typeof loaded === 'number' && loaded >= 0 ? loaded : 0;
      const validTotal = typeof total === 'number' && total > 0 ? total : null;
      const percent = validTotal ? Math.floor((validLoaded * 100) / validTotal) : 0;
      updateProgress(percent);
    });
    xhr.send(data);
    return new Promise((resolve, reject) => {
      xhr.addEventListener('load', () => resolve(xhr.response));
      xhr.addEventListener('error', () => reject(new Error(xhr.statusText)));
    });
  };

  return [upload];
};
